import type { JobPriceSource, RateBasis } from '@chukua/common';

/** Display labels for `RATE_BASES` — what a job's agreed price is per. */
export const RATE_BASIS_LABELS: Record<RateBasis, string> = {
  per_trip: 'Per trip',
  per_container: 'Per container',
  per_tonne: 'Per tonne',
  per_km: 'Per km',
};

export const PRICE_SOURCE_LABELS: Record<JobPriceSource, string> = {
  rate_card: 'From the rate card',
  manual: 'Off-card (typed in)',
};
